import { Investment, Investor, queries, Test } from 'procura-shared';
import React from 'react';
import { useCollectionData, useDocumentData } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import {
  Dashboard,
  InvestmentInfo,
  InvestmentsTable,
  InvestorInfo,
  InvestorsTable,
  TestsTable,
} from '../components/Components';
import '../styles/dashboard-page.less';
import { useLocalStorage } from '../utilities/Hooks';

export const AdminDashboardPage = () => {
  const { t } = useTranslation();

  const [selectedInvestmentId, setSelectedInvestmentId] = useLocalStorage<string>('adminSelectedInvestmentId', null);
  const [selectedInvestorId, setSelectedInvestorId] = useLocalStorage<string>('adminSelectedInvestortId', null);

  const [fbInvestments, fbInvestmentsLoading] = useCollectionData<Investment>(queries.investmentsQuery(), {
    idField: 'id',
  });
  const [fbSelectedInvestment, fbSelectedInvestmentLoading] = useDocumentData<Investment>(
    queries.investmentQuery(selectedInvestmentId),
    { idField: 'id' }
  );
  const [fbInvestors, fbInvestorsLoading] = useCollectionData<Investor>(queries.investorsQuery(), { idField: 'id' });
  const [fbSelectedInvestor, fbSelectedInvestorLoading] = useDocumentData<Investor>(
    queries.investorQuery(selectedInvestorId),
    {
      idField: 'id',
    }
  );
  const [fbTests, fbTestsLoading] = useCollectionData<Test>(queries.testsQuery(), { idField: 'id' });

  const [fbSelectedInvestmentInvestors, fbSelectedInvestmentInvestorsLoading] = useCollectionData<Investor>(
    // queryInvestors(),
    fbSelectedInvestment?.investors?.length > 10
      ? queries.investorsQuery()
      : queries.investmentInvestorsQuery(fbSelectedInvestment?.investors),
    { idField: 'id' }
  );

  const isSideActive = (): boolean => Boolean(!!selectedInvestmentId || !!selectedInvestorId);
  const sideTitle = (): string =>
    !!fbSelectedInvestor ? fbSelectedInvestor.name : !!fbSelectedInvestment ? fbSelectedInvestment.name : '';
  const sideCloseHandler = () => {
    setSelectedInvestmentId(null);
    setSelectedInvestorId(null);
  };
  const investorSelectHandler = (investor: Investor) => {
    setSelectedInvestmentId(null);
    setSelectedInvestorId(investor.id);
  };
  const investmentSelectHandler = (investment: Investment) => {
    setSelectedInvestorId(null);
    setSelectedInvestmentId(investment.id);
  };

  const renderSideInvestor = () => (
    <InvestorInfo
      loading={fbSelectedInvestorLoading}
      investor={fbSelectedInvestor}
      onSelect={investmentSelectHandler}
      adminMode
    />
  );

  const renderSideInvestment = () => (
    <InvestmentInfo
      investment={fbSelectedInvestment}
      investors={fbSelectedInvestmentInvestors}
      loading={fbSelectedInvestmentLoading || fbSelectedInvestmentInvestorsLoading}
      adminMode
      onInvestorSelect={investorSelectHandler}
    />
  );
  return (
    <Dashboard>
      <Dashboard.Loader loading={fbSelectedInvestorLoading || fbSelectedInvestmentLoading} />
      <Dashboard.Main
        titleName={'Admin'}
        sideActive={isSideActive()}
        panels={[
          {
            title: t('investors'),
            content: (
              <InvestorsTable
                investors={fbInvestors}
                loading={fbInvestorsLoading}
                onSelect={investorSelectHandler}
                search
                adminMode
              />
            ),
          },
          {
            title: t('investments'),
            content: (
              <InvestmentsTable
                investments={fbInvestments}
                loading={fbInvestmentsLoading}
                onSelect={investmentSelectHandler}
                table
                search
                scroll
                adminMode
              />
            ),
          },
          {
            title: t('tests'),
            content: <TestsTable tests={fbTests} loading={fbTestsLoading} />,
          },
        ]}></Dashboard.Main>
      <Dashboard.Side title={sideTitle()} active={isSideActive()} onClose={sideCloseHandler}>
        {!!fbSelectedInvestor ? renderSideInvestor() : renderSideInvestment()}
      </Dashboard.Side>
    </Dashboard>
  );
};
